import { makeAutoObservable, runInAction } from 'mobx';
import type { PopulatedSection } from 'root/types/menusTypes';
import { SectionState } from './SectionState';
import type { DispatchInfo } from 'root/types/businessTypes';

export class SectionsState {
  private sectionsMap: Map<string, SectionState> = new Map();

  constructor() {
    makeAutoObservable(this);
  }

  setSections(sections: PopulatedSection[]) {
    runInAction(() => {
      this.sectionsMap = new Map(
        sections.map((section) => [section.id, new SectionState(section)])
      );
    });
  }

  getSection(sectionId: string): SectionState | undefined {
    return this.sectionsMap.get(sectionId);
  }

  updateAvailabilityStatus(dispatchInfo: DispatchInfo) {
    runInAction(() => {
      this.sectionsMap.forEach((sectionState) => {
        sectionState.updateAvailabilityForDispatch(dispatchInfo);
      });
    });
  }

  clearSections() {
    runInAction(() => {
      this.sectionsMap.clear();
    });
  }
}

export const sectionsState = new SectionsState();
